import { get } from 'lodash';
import React, { memo } from 'react';
import type { CellProps } from 'react-table';

import type { TableColumnInstance, Tournament } from '../../../types/MTT';
import TournamentStatusIcons from '../../TournamentStatusIcons/TournamentStatusIcons';
import styles from '../shared.scss';

import TableCellBase from './TableCellBase';

type Props = CellProps<Tournament> & { showLabel?: boolean };

const TableCellGame: React.FC<Props> = memo((props) => {
  const { row } = props;

  const { renderValueAccessor = '' } = props.column as TableColumnInstance;
  const text = get(props.row.original, renderValueAccessor);

  const displayValue = (
    <div className={styles.cellGame}>
      <span>{text}</span>&nbsp;
      <TournamentStatusIcons {...row.original} />
    </div>
  );

  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellGame;
